module.exports = __webpack_public_path__ + "1791188489487/fonts/socicon.944f06f.woff";